import * as Common from "../../commons/common"

export class SheetListCondition{
  cram_student_id: string = ""
  sheet_code: string = ""
  nendo: number
  month: string = ""
  curriculum_id: string = ""
  grade: string = ""
  room_code: string = ""
  page: number = 1
  times: string = ""
  row_count: number =  Common.SheetListRowCount
  course_code: string = ""
  event_code: string = ""
}

export class Sheet{
  id: number
  base_sheet_id: number
  sheet_code: string
  nendo: number
  month: number
  times: number
  sheet_name: string
  sheet_content: string
  curriculum_id: number
  grade: number
  level: string
  room_name: string
  class_name: string
  student_count: number
  capture_date: string
  field_positions_completed: boolean
  explanation_image_completed: boolean
  score: number
  full_count: number
  class_avg_score: string
  class_rank: number
  class_std_score: string
  all_avg_score: string
  all_rank: number
  all_std_score: string
  student_count_all: number
  page_count: number
  base64Images: string[] = []
  base64Pdf: string
  url: string
  cocurse_name: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.base_sheet_id = sheet.base_sheet_id;
    this.sheet_code = sheet.sheet_code;
    this.nendo = sheet.nendo;
    this.month = sheet.month;
    this.times = sheet.times;
    this.sheet_name = sheet.sheet_name;
    this.sheet_content = sheet.sheet_content;
    this.curriculum_id = sheet.curriculum_id;
    this.grade = sheet.grade;
    this.level = sheet.level;
    this.room_name = sheet.room_name;
    this.class_name = sheet.class_name;
    this.student_count = sheet.student_count;
    this.capture_date = sheet.capture_date;
    this.field_positions_completed = sheet.field_positions_completed;
    this.explanation_image_completed = sheet.explanation_image_completed;
    this.score = sheet.score;
    this.full_count = sheet.full_count;
    this.class_avg_score = sheet.class_avg_score;
    this.class_rank = sheet.class_rank;
    this.class_std_score = sheet.class_std_score;
    this.all_avg_score = sheet.all_avg_score;
    this.all_rank = sheet.all_rank;
    this.all_std_score = sheet.all_std_score;
    this.student_count_all = sheet.student_count_all;
    this.page_count = sheet.page_count;
    this.url = sheet.url;
    this.cocurse_name = sheet.course_name == null ? "-" : sheet.course_name;
  }
}

export class CramStudent {
  student_code: number
  cram_code: number
  name: string
  nendo: number
  grade: number
  room_code: number
  room_name: string
  class_code: number
  class_name: string

  constructor(student: any){
    this.student_code = student.student_code;
    this.cram_code = student.cram_code;
    this.name = student.name;
    this.nendo = student.nendo;
    this.grade = student.grade;
    this.room_code = student.room_code;
    this.room_name = student.room_name;
    this.class_code = student.class_name;
    this.class_name = student.class_name;
  }
}

export class Course {
  course_code: number
  name: string
  
  constructor(x: any){
    this.course_code = x.course_code;
    this.name = x.name;
  }
}